import { call, put, select, takeLeading } from 'typed-redux-saga'
import { errorHandler, loadersSlice } from 'Modules'
import { Deserialize } from 'cerialize'
import { ResponseCatalog, RequestParams } from 'Models'
import { Callback } from 'Src/types/utilTypes'
import {
	actUnpaidSlice,
	ActsSelector,
	ActUnpaidCounterModel,
	ActUnpaidModel,
	ActsUnpaidSelector,
	actUnpaidApi,
	actUnpaidNS,
} from 'Pages/acts'

function* getAllUnpaidActs(clear?: boolean, requestParams?: RequestParams, callback?: Callback) {
	let params = yield* select(ActsUnpaidSelector.getUnpaidActsRequestParams)
	let oldActs = new ResponseCatalog<ActUnpaidModel>()
	yield* put(loadersSlice.actions.showGlobalLoader())
	if (!clear && requestParams?.page !== 1) {
		oldActs = yield* select(ActsUnpaidSelector.getUnpaidActs)
	} else if (clear) {
		const { page, per_page = 30, query = undefined, ...rest } = { ...params, page: 1 }
		params = new RequestParams(page, per_page, query, rest)
		yield* put(actUnpaidSlice.actions.clearUnpaidActs())
		yield* put(actUnpaidSlice.actions.setUnpaidActsRequestParams(params))
	}
	const filterName = yield* select(ActsSelector.getCurrentActsFilter)
	const res = yield* call(actUnpaidApi.getUnpaidActsFilteredBy, filterName, requestParams || params)
	const acts = new ResponseCatalog<ActUnpaidModel>(res)
	const newActs = res.entries.map((act): ActUnpaidModel => Deserialize(act, ActUnpaidModel))
	acts.entries = [...oldActs.entries, ...newActs]
	yield* put(actUnpaidSlice.actions.setUnpaidActs(acts))
	yield* put(loadersSlice.actions.hideGlobalLoader())
	callback?.()
}

function* getUnpaidActsSaga(action: actUnpaidNS.getUnpaidActs) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const { params, clear } = action.payload
		yield* call(getAllUnpaidActs, clear, params)
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(errorHandler, error)
	}
}

function* getUnpaidActsCounterSaga() {
	try {
		const res = yield* call(actUnpaidApi.getUnpaidActsCounter)
		const counter = Deserialize(res, ActUnpaidCounterModel)
		yield* put(actUnpaidSlice.actions.setUnpaidActsCounter(counter))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export const actUnpaidSaga = function* saga() {
	yield* takeLeading(actUnpaidSlice.actions.getUnpaidActs.type, getUnpaidActsSaga)
	yield* takeLeading(actUnpaidSlice.actions.getUnpaidActsCounter.type, getUnpaidActsCounterSaga)
}
